import { HardHat, Leaf, ShieldAlert, FileCheck } from "lucide-react";

const PRINCIPLES = [
  {
    icon: HardHat,
    title: "Zero-accident culture",
    body: "Site-wide PPE enforcement, daily toolbox talks, and incident-free targets on every project.",
  },
  {
    icon: ShieldAlert,
    title: "Regular safety audits",
    body: "Scheduled and surprise audits at every site to validate adherence to safety protocols.",
  },
  {
    icon: Leaf,
    title: "Environmentally responsible",
    body: "Dust control, waste segregation and water-recharge practices integrated into every scope.",
  },
  {
    icon: FileCheck,
    title: "IS-code compliance",
    body: "Materials, mix designs and execution methodology validated to relevant IS codes and project specs.",
  },
];

export default function HSE() {
  return (
    <section
      id="hse"
      data-testid="hse-section"
      className="py-24 md:py-32 bg-bone text-ink"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-14 md:mb-16">
          <div className="md:col-span-7">
            <span className="tech-rule">05 — HSE & Quality</span>
            <h2
              data-testid="hse-heading"
              className="mt-6 font-heading font-black uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.9] tracking-tighter"
            >
              Safety isn't<br />
              an afterthought.<br />
              <span className="italic font-medium text-rust">It's the foundation.</span>
            </h2>
          </div>
          <p className="md:col-span-4 md:col-start-9 text-graphite leading-relaxed self-end">
            Health, Safety & Environment is wired into every site protocol — from
            PPE compliance to material certification.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border border-ink">
          {PRINCIPLES.map((p, i) => {
            const Icon = p.icon;
            return (
              <div
                key={p.title}
                data-testid={`hse-principle-${i}`}
                className="p-7 md:p-8 border-ink [&:not(:last-child)]:border-b md:[&:not(:nth-child(2n))]:border-r md:[&:nth-child(n+3)]:border-b-0 lg:[&]:border-b-0 lg:[&:not(:last-child)]:border-r lg:[&:not(:nth-child(2n))]:border-r bg-bone hover:bg-ink hover:text-bone transition-colors group"
              >
                <div className="inline-flex items-center justify-center w-11 h-11 border border-ink group-hover:border-bone mb-5">
                  <Icon className="w-5 h-5" strokeWidth={2} />
                </div>
                <h3 className="font-heading font-bold text-xl md:text-2xl tracking-tight leading-tight mb-3">
                  {p.title}
                </h3>
                <p className="text-sm leading-relaxed text-graphite group-hover:text-bone/75">
                  {p.body}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
